import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import type {
  DeadlineAnchor,
  DeadlineDirection,
  DeadlineOffset,
} from "./deadlineOffset";
import { deadlineLabel } from "./deadlineOffset";

export function DeadlineOffsetEditor({
  value,
  onChange,
}: {
  value: DeadlineOffset;
  onChange: (v: DeadlineOffset) => void;
}) {
  if (value.mode === "NONE") {
    return (
      <div className="space-y-1">
        <Button
          variant="outline"
          size="sm"
          className="h-7 text-xs"
          onClick={() =>
            onChange({
              mode: "SET",
              days: 0,
              anchor: "START",
              direction: "BEFORE",
            })
          }
        >
          Aseta määräaika
        </Button>
        <div className="text-[11px] text-muted-foreground">Ei määräaikaa</div>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <div className="flex flex-wrap items-center gap-1.5">
        <Input
          type="number"
          min={0}
          value={value.days}
          className="h-7 w-16 text-xs"
          onChange={(e) =>
            onChange({ ...value, days: Math.max(0, Number(e.target.value) || 0) })
          }
        />
        <span className="text-xs text-muted-foreground">päivää</span>
        <Select
          value={value.direction}
          onValueChange={(v) =>
            onChange({ ...value, direction: v as DeadlineDirection })
          }
        >
          <SelectTrigger className="h-7 w-[92px] text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="BEFORE">ennen</SelectItem>
            <SelectItem value="AFTER">jälkeen</SelectItem>
          </SelectContent>
        </Select>
        <Select
          value={value.anchor}
          onValueChange={(v) => onChange({ ...value, anchor: v as DeadlineAnchor })}
        >
          <SelectTrigger className="h-7 w-[120px] text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="START">töiden alun</SelectItem>
            <SelectItem value="END">töiden lopun</SelectItem>
          </SelectContent>
        </Select>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 text-xs text-muted-foreground"
          onClick={() => onChange({ mode: "NONE" })}
        >
          Tyhjennä
        </Button>
      </div>
      <div className="text-[11px] text-muted-foreground">
        {deadlineLabel(value)}
      </div>
    </div>
  );
}
